import { ComponentType, ReactNode } from 'react';
import classes from './FigmaTransparentLayout.module.scss';

const DefaultRenderForm: FigmaTransparentLayoutProps['RenderForm'] = ({
  children,
  className,
}) => <div className={className}>{children}</div>;

// const DefaultRenderHeader: FigmaTransparentLayoutProps['RenderHeader'] = ({
//   children,
//   className,
// }) => <h2 className={className}>{children}</h2>;

export type FigmaTransparentLayoutProps = {
  slotHeader?: ReactNode;
  slotTitle?: ReactNode;
  slotButtons?: ReactNode;
  RenderHeader?: ComponentType<{ className?: string; children?: ReactNode }>;
  RenderForm?: ComponentType<{ className: string; children: ReactNode }>;
  slotError?: ReactNode;
  children: ReactNode;
};

export const FigmaTransparentLayout = ({
  // slotHeader,
  slotTitle,
  slotButtons,
  // RenderHeader = DefaultRenderHeader,
  RenderForm = DefaultRenderForm,
  slotError,
  children,
}: FigmaTransparentLayoutProps) => {
  return (
    <div className={classes.content}>
      {/* <RenderHeader className={classes.header}>{slotHeader}</RenderHeader> */}
      <RenderForm className={classes.form}>
        {slotTitle && <div className={classes.title}>{slotTitle}</div>}
        <div>{children}</div>
        <div className={classes.placeholder} />
        {slotError && <div className={classes.error}>{slotError}</div>}
        {slotButtons}
      </RenderForm>
    </div>
  );
};
